var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMassachusetts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "207.041,205.437 209.23,209.817 231.624,201.054 222.617,195.457  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.233,202.639 265.218,202.639 257.67,191.316  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.233,169.898c0,0-4.544-30.508-9.013-33.755c-4.465-3.24-18.25-1.947-18.25-1.947l3.894,5.843 c0,0,15.581,3.243,14.28,15.577c-1.297,12.333-26.609,6.487-26.609,6.487s-20.123-25.961-23.37-31.152 c-3.247-5.194-12.329,4.543-12.329,4.543l-9.088-13.633l12.979-24.015c0,0-10.006-11.909-14.91-16.128 c-0.816-0.702-1.502-1.215-1.967-1.4c-3.242-1.298-22.068,19.477-22.068,19.477L67.25,116.251l-28.411,5.951l-16.62,3.48 c0.113,1.204,0.19,2.317,0.23,3.322c0.268,7.019,0.653,17.966,1.148,29.06c0.554,12.463,1.252,25.095,2.09,32.571l102.564-20.737 l27.914-7.794l23.947,31.572l14.352,4.784c0,0,0.648-5.844,0.648-12.984c0-7.14,12.334-10.388,12.334-10.388l1.297,18.503 c0,0,9.737-2.275,9.088-4.868C217.186,186.127,252.233,169.898,252.233,169.898z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassachusetts);
export default __webpack_public_path__ + "static/media/massachusetts.d66a04389046497e53acc6a3f30e56a3.svg";
export { ForwardRef as ReactComponent };